import { useEffect } from "react";

import { useClearActiveContainerElementState } from "./useActiveElementState";

export const ResetActiveElementState = () => {
  const clearState = useClearActiveContainerElementState();

  useEffect(() => {
    // Reset the state on unmount.
    return () => {
      clearState();
    };
  }, [clearState]);

  return null;
};
